import React from "react";
import { Box, Typography } from "@mui/material";
import AddButton from "../AddButton/AddButton";

interface InfoBarProps {
    message: string;
    buttonLabel?: string;
    onButtonClick?: any;
    borderColor?: string;
    backgroundColor?: string;
    textColor?: string;
    maxButtonWidth?: string;
}

const InfoBar: React.FC<InfoBarProps> = ({
    message,
    buttonLabel,
    onButtonClick,
    borderColor = "rgba(25, 118, 210, 0.5)",
    backgroundColor = "#eaebf0",
    textColor = "rgba(110, 112, 121, 1)",
    maxButtonWidth = '202px'
}) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: `1px solid ${borderColor}`,
                borderRadius: "6px",
                backgroundColor,
                padding: "8px",
                margin: '10px 0',
                marginRight: '-10px'
            }}
        >
            <Typography
                sx={{
                    color: textColor,
                    fontSize: "14px",
                    fontFamily: 'Inter',
                    fontWeight: 500
                }}
            >
                {message}
            </Typography>

            {buttonLabel && (
                <AddButton
                    onAddClick={onButtonClick}
                    addLabel={buttonLabel}
                    maxWidth={maxButtonWidth}
                />
            )}
        </Box>
    );
};

export default InfoBar;